import {
  Box,
  ButtonGroup,
  Flex,
  IconButton,
  useDisclosure,
} from "@chakra-ui/react";
import { observer } from "mobx-react";
import { NodeNavControls } from "../../../../../shared/views/NodeNavControls/NodeNavControls";
import { NodePhotoModal } from "../../../../../shared/views/NodePhotoModal/NodePhotoModal";
import { useStores } from "../../../../../shared/stores/RootStore";
import { ExpandIcon } from "../../../../../shared/views/icons";
import { NodePhoto } from "../../../../../shared/views/NodePhoto/NodePhoto";

const NodeThumbnailBase: React.FC = () => {
  const { craNodeStore } = useStores();

  const node = craNodeStore.getSelected()!;
  const nodePhotoModal = useDisclosure();

  return (
    <>
      <Box position="relative" width="100%" flexShrink={0}>
        <NodePhoto node={node} />

        <Flex
          justifyContent="center"
          position="absolute"
          bottom={2}
          right={0}
          left={0}
        >
          <NodeNavControls />
        </Flex>
        <Box position="absolute" top={2} right={2}>
          <ButtonGroup size="sm" colorPalette="primary">
            <IconButton
              onClick={nodePhotoModal.onOpen}
              aria-label="Enlarge image"
              variant={"ghost"}
            >
              <ExpandIcon />
            </IconButton>
          </ButtonGroup>
        </Box>
      </Box>

      {nodePhotoModal.open && (
        <NodePhotoModal onClose={nodePhotoModal.onClose} />
      )}
    </>
  );
};

export const NodeThumbnail = observer(NodeThumbnailBase);
